import FormattedMessage from 'I18n/components/FormattedMessage';
import { ACTION_CONTEXTS } from '../constants/actionContexts.constants';
import { OUTAGE_REASONS } from '../constants/outageReasons.constants';
import { jsx as _jsx } from "react/jsx-runtime";
const FintechOutageBannerTitle = ({
  serviceAvailabilityStatus,
  actionContext = ACTION_CONTEXTS.ANY
}) => {
  const reason = serviceAvailabilityStatus === null || serviceAvailabilityStatus === void 0 ? void 0 : serviceAvailabilityStatus.outageReason;
  const isPlanned = reason === OUTAGE_REASONS.PLANNED_OUTAGE;
  const isPurchase = actionContext === ACTION_CONTEXTS.PURCHASE;
  if (isPlanned && isPurchase) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "account-and-billing-fintech-outages.fintech-outage-banner.title.planned-purchase"
    });
  }
  if (isPlanned) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "account-and-billing-fintech-outages.fintech-outage-banner.title.planned-any"
    });
  }
  if (isPurchase) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "account-and-billing-fintech-outages.fintech-outage-banner.title.unplanned-purchase"
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "account-and-billing-fintech-outages.fintech-outage-banner.title.unplanned-any"
  });
};
export default FintechOutageBannerTitle;